<template>
  <div class="instruction-text" v-if="instructionText">
    <div class="instruction-text__content">
      <div class="instruction-text__icon">
        <b-icon icon="info-circle" variant="info"></b-icon>
      </div>
      <div class="instruction-text__text">
        <div v-html="instructionText"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InstructionText',
  
  props: {
    // Тип пользователя: agent, manager, admin и т.д.
    userType: {
      type: String,
      required: true,
      validator: value => ['agent', 'manager', 'admin', 'logist'].includes(value)
    },
         // Раздел: order-details, order-finance, order-documents и т.д.
     section: {
       type: String,
       required: true,
       validator: value => [
         'order-details', 
         'order-finance', 
         'order-documents', 
         'order-tasks',
         'order-outsourcing',
         'order-customs',
         'order-certification',
         'order-consulting',
         'order-logistics',
         'order-logistics-request',
         'order-logistics-supply',
         'order-pnk',
         'order-svh',
         'order-insurance',
         'order-suppliers',
         'order-finance-requests',
         'order-create'
       ].includes(value)
     },
    // Дополнительные данные для контекстных инструкций
    contextData: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    instructionText() {
      const instructions = this.getInstructions();
      return instructions[this.userType]?.[this.section] || null;
    }
  },

  methods: {
    getInstructions() {
      return {
        agent: {
          'order-details': `
            <strong>Инструкция - Детали заказа:</strong>
            <ul class="instruction-list">
                <li>Проверьте все данные заказа на корректность.</li>
                <li>Работа с конкретными услугами ведется на соответствующих вкладках слева. Чтобы услуги появились их нужно добавить в карточке заказа.</li>
                <li>Убедитесь, что контактная информация клиента актуальна.</li>
                <li>При необходимости внесите изменения в детали заказа.</li>
                <li>Обращайте внимание на статус заказа.</li>
            </ul>

            <div class="mt-2">
                <em>У любого заказа есть два состояния: Запрос и Поставка.</em>
                <div class="mt-1 mb-3">
                    <strong>Возможные статусы Запроса:</strong>
                    <ul class="instruction-list">
                        <li>Запросы / Лиды - Заказ только что создан, идет сбор информации.</li>
                        <li>Контакт с клиентом - Статус необходимый для систематизации работы, не обязателен.</li>
                        <li>Получение котировки - Заявку из этого статуса могут перевести только сотрудники компании, оценив все услуги.</li>
                        <li>Котировка получена - после оценки всех услуг, заявка переводится в этот статус.</li>
                        <li>КП направлено - Вы назначаете ставки для клиента и переводите Заявку в этот статус.</li>
                        <li>Связаться позже - Если получили отказ или клиент пока не готов к заключению договора.</li>
                    </ul>
                </div>
                <em>В случае, если клиент готов с нами работать, вы переводите Заявку в статус "Поставка".</em>
                <div class="mt-1">
                    <strong>Возможные статусы Поставки:</strong>
                    <ul class="instruction-list">
                        <li>Открыт - Поставка началась.</li>
                        <li>Завершен - Поставка завершена, то есть выполнена работа по Поставке.</li>
                        <li>Отказ - Поставка отменена нами или клиентом.</li>
                        <li>Ожидает оплаты - Ожидает оплаты.</li>
                        <li>Закрыт - Поставка полностью завершена и оплачена, за неё вы получаете вознаграждение.</li>
                        <li>Невозможно взыскать - Данный статус выставляется, если клиент отказывается платить.</li>
                    </ul>
                </div>
                <em>В случае, если клиент готов с нами работать, вы переводите Заявку в статус "Поставка".</em>
            </div>
          `,
          'order-finance': `
            <strong>Инструкция - Счета:</strong>
            <ul class="instruction-list">
                <li>Следите за статусом оплаты счетов.</li>
                <li>В случае возникновения вопросов по счетам, создайте Запрос бухгултеру (напротив счета).</li>
            </ul>
          `,
          'order-finance-requests': `
            <strong>Инструкция - Запросы:</strong>
            <ul class="instruction-list">
                <li>Здесь собраны все запросы по поставке в Бухгалтерию.</li>
                <li>Вы можете создать новый запрос в разделе Счета, напротив счета, в колонке Действия.</li>
                <li>Отслеживайте статус запроса в колонке Статус.</li>
            </ul>
          `,
          'order-documents': `
            <strong>Инструкция - Документы:</strong>
            <ul class="instruction-list">
                <li>Загрузите все необходимые документы по Поставке в этот раздел (КП, Спецификации и так далее).</li>
                <li>Документы по Компании должны быть загружены в карточке компании (Договор, Свидетельство и т.д.).</li>
                <li>Документы касающиеся конкретных услуг, загружаются в карточке услуги.</li>
                <li>Документы по счетам, загружаются в карточке счета.</li>
            </ul>
          `,
          'order-tasks': `
            <strong>Инструкция - Задачи:</strong>
            <ul class="instruction-list">
                <li>Создавайте задачи для отслеживания важных этапов.</li>
                <li>Назначайте ответственных за выполнение задач.</li>
                <li>Устанавливайте сроки выполнения.</li>
                <li>Отслеживайте прогресс выполнения задач.</li>
            </ul>
          `,
          'order-outsourcing': `
            <strong>Инструкция - Расчёты:</strong>
            <ul class="instruction-list">
                <li>Проверьте все расчёты по аутсорсингу.</li>
                <li>Убедитесь в корректности тарифов.</li>
                <li>Следите за выполнением обязательств.</li>
                <li>Контролируйте качество услуг.</li>
            </ul>
          `,
          'order-customs': `
            <strong>Инструкция - Таможенное оформление:</strong>
            <ul class="instruction-list">
                <li>Все необходимые поля будут заполнены менеджером, который будет вести Поставку.</li>
                <li>Все документы, касающиеся данной услуги будут прикреплены здесь.</li>
            </ul>
          `,
          'order-certification': `
            <strong>Инструкция - Сертификация:</strong>
            <ul class="instruction-list">
                <li>Все необходимые поля будут заполнены менеджером, который будет вести Поставку.</li>
                <li>Все документы, касающиеся данной услуги будут прикреплены здесь.</li>
            </ul>
          `,
          'order-consulting': `
            <strong>Инструкция - Консалтинг:</strong>
            <ul class="instruction-list"> 
                <li>Определите потребности клиента в консалтинге.</li>
                <li>Подготовьте предложения по услугам.</li>
                <li>Следите за выполнением консультационных услуг.</li>
                <li>Контролируйте качество предоставляемых услуг.</li>
                <li>Все необходимые поля будут заполнены менеджером, который будет вести Поставку.</li>
                <li>Все документы, касающиеся данной услуги будут прикреплены здесь.</li>
            </ul>
          `,
          'order-logistics-request': `
            <strong>Инструкция - Логистика:</strong>
            <ul class="instruction-list">
                <li>Вам необходимо заполнить форму котировки, в которой будут все данные о грузе и маршруте.</li>
                <li>Вы можете выбрать несколько типов перевозок для котировки поставки. Наши логисты посчитают каждый из них.</li>
                <li>После того, как логисты посчитают все возможные варианты, вы сможете выбрать наиболее подходящий для клиента.</li>
                <li>После выбора варианта типа перевозки, установите цену для клиента.</li>
                <li>Сформируйте и отправьте Коммерческое Предложение (КП) клиенту.</li>
                <li>После того, как клиент примет и согласует КП, вы можете перевести Заказ в статус "Поставка".</li>
                <li>Если клиент отказывается от котировки, вы можете запросить скидку у нашего Логиста. Если скидка будет возможна, вы сможете сформировать новое КП.</li>
                <li>Все документы, касающиеся данной услуги будут прикреплены здесь.</li>
            </ul>
          `,
          'order-logistics-supply': `
            <strong>Инструкция - Логистика:</strong>
            <ul class="instruction-list">
                <li>Все необходимые поля будут заполнены менеджером, который будет вести Поставку.</li>
                <li>Все документы, касающиеся данной услуги будут прикреплены здесь.</li>
                <li>Следите за статусами ведения Поставки в комментариях к услуге Логистика.</li>
            </ul>
          `,
          'order-pnk': `
            <strong>Инструкция - ПНК:</strong>
            <ul class="instruction-list">
                <li>Проверьте все документы для ПНК.</li>
                <li>Убедитесь в корректности оформления.</li>
                <li>Следите за сроками прохождения ПНК.</li>
                <li>Контролируйте процесс проверки.</li>
            </ul>
          `,
          'order-svh': `
            <strong>Инструкция - СВХ:</strong>
            <ul class="instruction-list">
                <li>Проверьте документы для СВХ.</li>
                <li>Убедитесь в корректности оформления.</li>
                <li>Следите за сроками хранения.</li>
                <li>Контролируйте условия хранения.</li>
            </ul>
          `,
          'order-insurance': `
            <strong>Инструкция - Страхование:</strong>
            <ul class="instruction-list">
                <li>Проверьте условия страхования.</li>
                <li>Убедитесь в корректности страховых документов.</li>
                <li>Следите за сроками действия страховки.</li>
                <li>Контролируйте покрытие страховых случаев.</li>
            </ul>
          `,
          'order-suppliers': `
            <strong>Инструкция - Поставщики:</strong>
            <ul class="instruction-list">
                <li>Проверьте информацию о поставщиках.</li>
                <li>Убедитесь в актуальности контактных данных.</li>
                <li>Следите за выполнением обязательств поставщиками.</li>
                <li>Контролируйте качество поставляемых товаров.</li>
            </ul>
          `,
          'order-create': `
            <strong>Инструкция по созданию заявки:</strong>
            <ul class="instruction-list">
                <li>Заполняйте подробно все поля заявки для корректной обработки.</li>
                <li>При выборе компании используйте только собственный каталог компаний.</li>
                <li>Все выбранные компании фиксируются за вами как за создателем.</li>
                <li>Если необходимая компания уже существует в каталоге, система проинформирует вас об этом.</li>
                <li>К компаниям, которые уже существуют в каталоге, но не закреплены за вами, у вас не будет доступа для работы.</li>
                <li>При выборе компании обязательно прикрепите контактное лицо.</li>
                <li>Контактное лицо - обязательное требование для ведения заказа.</li>
                <li>Без контактного лица невозможно перевести заявку в поставку.</li>
            </ul>
          `
        },
        // manager: {
        //   'order-details': `
        //     <strong>Инструкция для менеджера - Детали заказа:</strong><br>
        //     • Контролируйте правильность заполнения всех полей<br>
        //     • Проверяйте соответствие заказа требованиям клиента<br>
        //     • Убедитесь в корректности назначенных ответственных<br>
        //     • Следите за соблюдением сроков выполнения
        //   `,
        //   'order-finance': `
        //     <strong>Инструкция для менеджера - Счета:</strong><br>
        //     • Контролируйте корректность выставления счетов<br>
        //     • Проверяйте соответствие тарифов и условий<br>
        //     • Следите за своевременностью оплаты<br>
        //     • Управляйте дебиторской задолженностью
        //   `,
        //   'order-documents': `
        //     <strong>Инструкция для менеджера - Документы:</strong><br>
        //     • Контролируйте полноту и качество документов<br>
        //     • Проверяйте соответствие документов стандартам<br>
        //     • Следите за сроками подготовки документов<br>
        //     • Управляйте процессом согласования
        //   `,
        //   'order-tasks': `
        //     <strong>Инструкция для менеджера - Задачи:</strong><br>
        //     • Распределяйте задачи между сотрудниками<br>
        //     • Контролируйте выполнение задач в срок<br>
        //     • Проверяйте качество выполнения<br>
        //     • Управляйте приоритетами задач
        //   `,
        //   'order-outsourcing': `
        //     <strong>Инструкция для менеджера - Расчёты:</strong><br>
        //     • Контролируйте эффективность аутсорсинга<br>
        //     • Проверяйте качество предоставляемых услуг<br>
        //     • Управляйте отношениями с подрядчиками<br>
        //     • Оптимизируйте затраты на аутсорсинг
        //   `,
        //   'order-customs': `
        //     <strong>Инструкция для менеджера - Таможенное оформление:</strong><br>
        //     • Контролируйте процесс таможенного оформления<br>
        //     • Проверяйте корректность деклараций<br>
        //     • Управляйте сроками прохождения таможни<br>
        //     • Следите за соблюдением таможенного законодательства
        //   `,
        //   'order-certification': `
        //     <strong>Инструкция для менеджера - Сертификация:</strong><br>
        //     • Контролируйте процесс сертификации<br>
        //     • Проверяйте соответствие стандартам<br>
        //     • Управляйте сроками получения сертификатов<br>
        //     • Следите за актуальностью сертификатов
        //   `,
        //   'order-consulting': `
        //     <strong>Инструкция для менеджера - Консалтинг:</strong><br>
        //     • Контролируйте качество консультационных услуг<br>
        //     • Проверяйте удовлетворённость клиентов<br>
        //     • Управляйте процессом оказания услуг<br>
        //     • Следите за эффективностью консалтинга
        //   `,
        //   'order-logistics': `
        //     <strong>Инструкция для менеджера - Логистика:</strong><br>
        //     • Контролируйте логистические процессы<br>
        //     • Проверяйте оптимальность маршрутов<br>
        //     • Управляйте транспортными расходами<br>
        //     • Следите за качеством доставки
        //   `,
        //   'order-pnk': `
        //     <strong>Инструкция для менеджера - ПНК:</strong><br>
        //     • Контролируйте процесс прохождения ПНК<br>
        //     • Проверяйте корректность документов<br>
        //     • Управляйте сроками проверки<br>
        //     • Следите за соблюдением требований
        //   `,
        //   'order-svh': `
        //     <strong>Инструкция для менеджера - СВХ:</strong><br>
        //     • Контролируйте условия хранения на СВХ<br>
        //     • Проверяйте корректность оформления<br>
        //     • Управляйте сроками хранения<br>
        //     • Следите за сохранностью грузов
        //   `,
        //   'order-insurance': `
        //     <strong>Инструкция для менеджера - Страхование:</strong><br>
        //     • Контролируйте условия страхования<br>
        //     • Проверяйте покрытие страховых случаев<br>
        //     • Управляйте страховыми выплатами<br>
        //     • Следите за актуальностью страховки
        //   `,
        //   'order-suppliers': `
        //     <strong>Инструкция для менеджера - Поставщики:</strong><br>
        //     • Контролируйте качество поставщиков<br>
        //     • Проверяйте выполнение обязательств<br>
        //     • Управляйте отношениями с поставщиками<br>
        //     • Следите за конкурентоспособностью цен
        //   `
        // },
        // admin: {
        //   'order-details': `
        //     <strong>Инструкция для администратора - Детали заказа:</strong><br>
        //     • Системный контроль всех процессов<br>
        //     • Мониторинг производительности системы<br>
        //     • Управление правами доступа пользователей<br>
        //     • Анализ эффективности работы
        //   `,
        //   'order-finance': `
        //     <strong>Инструкция для администратора - Счета:</strong><br>
        //     • Системный контроль финансовых операций<br>
        //     • Мониторинг безопасности транзакций<br>
        //     • Управление финансовыми настройками<br>
        //     • Анализ финансовых показателей
        //   `,
        //   'order-documents': `
        //     <strong>Инструкция для администратора - Документы:</strong><br>
        //     • Системный контроль документооборота<br>
        //     • Мониторинг безопасности документов<br>
        //     • Управление шаблонами документов<br>
        //     • Анализ эффективности документооборота
        //   `,
        //   'order-tasks': `
        //     <strong>Инструкция для администратора - Задачи:</strong><br>
        //     • Системный контроль управления задачами<br>
        //     • Мониторинг производительности сотрудников<br>
        //     • Управление настройками задач<br>
        //     • Анализ эффективности работы команды
        //   `,
        //   'order-outsourcing': `
        //     <strong>Инструкция для администратора - Расчёты:</strong><br>
        //     • Системный контроль аутсорсинга<br>
        //     • Мониторинг качества внешних услуг<br>
        //     • Управление отношениями с подрядчиками<br>
        //     • Анализ эффективности аутсорсинга
        //   `,
        //   'order-customs': `
        //     <strong>Инструкция для администратора - Таможенное оформление:</strong><br>
        //     • Системный контроль таможенных процессов<br>
        //     • Мониторинг соблюдения законодательства<br>
        //     • Управление таможенными настройками<br>
        //     • Анализ эффективности таможенного оформления
        //   `,
        //   'order-certification': `
        //     <strong>Инструкция для администратора - Сертификация:</strong><br>
        //     • Системный контроль процессов сертификации<br>
        //     • Мониторинг соответствия стандартам<br>
        //     • Управление сертификационными настройками<br>
        //     • Анализ эффективности сертификации
        //   `,
        //   'order-consulting': `
        //     <strong>Инструкция для администратора - Консалтинг:</strong><br>
        //     • Системный контроль консультационных услуг<br>
        //     • Мониторинг качества консалтинга<br>
        //     • Управление консалтинговыми настройками<br>
        //     • Анализ эффективности консалтинга
        //   `,
        //   'order-logistics': `
        //     <strong>Инструкция для администратора - Логистика:</strong><br>
        //     • Системный контроль логистических процессов<br>
        //     • Мониторинг эффективности доставки<br>
        //     • Управление логистическими настройками<br>
        //     • Анализ логистических показателей
        //   `,
        //   'order-pnk': `
        //     <strong>Инструкция для администратора - ПНК:</strong><br>
        //     • Системный контроль процессов ПНК<br>
        //     • Мониторинг соблюдения требований<br>
        //     • Управление настройками ПНК<br>
        //     • Анализ эффективности проверок
        //   `,
        //   'order-svh': `
        //     <strong>Инструкция для администратора - СВХ:</strong><br>
        //     • Системный контроль процессов СВХ<br>
        //     • Мониторинг условий хранения<br>
        //     • Управление настройками СВХ<br>
        //     • Анализ эффективности хранения
        //   `,
        //   'order-insurance': `
        //     <strong>Инструкция для администратора - Страхование:</strong><br>
        //     • Системный контроль страховых процессов<br>
        //     • Мониторинг страхового покрытия<br>
        //     • Управление страховыми настройками<br>
        //     • Анализ эффективности страхования
        //   `,
        //   'order-suppliers': `
        //     <strong>Инструкция для администратора - Поставщики:</strong><br>
        //     • Системный контроль поставщиков<br>
        //     • Мониторинг качества поставок<br>
        //     • Управление базой поставщиков<br>
        //     • Анализ эффективности поставок
        //   `
        // },
        // logist: {
        //   'order-details': `
        //     <strong>Инструкция для логиста - Детали заказа:</strong><br>
        //     • Проверьте логистические требования заказа<br>
        //     • Убедитесь в корректности адресов доставки<br>
        //     • Проверьте габариты и вес груза<br>
        //     • Оцените требования к транспортировке
        //   `,
        //   'order-finance': `
        //     <strong>Инструкция для логиста - Счета:</strong><br>
        //     • Проверьте транспортные расходы в счетах<br>
        //     • Убедитесь в корректности логистических тарифов<br>
        //     • Следите за оплатой транспортных услуг<br>
        //     • Контролируйте логистические затраты
        //   `,
        //   'order-documents': `
        //     <strong>Инструкция для логиста - Документы:</strong><br>
        //     • Проверьте наличие транспортных документов<br>
        //     • Убедитесь в корректности товарно-транспортных накладных<br>
        //     • Следите за оформлением документов для перевозки<br>
        //     • Контролируйте таможенные документы
        //   `,
        //   'order-tasks': `
        //     <strong>Инструкция для логиста - Задачи:</strong><br>
        //     • Создавайте задачи по логистическим операциям<br>
        //     • Назначайте ответственных за транспортировку<br>
        //     • Устанавливайте сроки доставки<br>
        //     • Отслеживайте выполнение логистических задач
        //   `,
        //   'order-outsourcing': `
        //     <strong>Инструкция для логиста - Расчёты:</strong><br>
        //     • Проверьте логистические услуги аутсорсинга<br>
        //     • Убедитесь в корректности транспортных тарифов<br>
        //     • Следите за качеством логистических услуг<br>
        //     • Контролируйте эффективность аутсорсинга
        //   `,
        //   'order-customs': `
        //     <strong>Инструкция для логиста - Таможенное оформление:</strong><br>
        //     • Подготовьте документы для таможенного оформления<br>
        //     • Проверьте корректность деклараций<br>
        //     • Следите за сроками таможенного оформления<br>
        //     • Контролируйте прохождение таможенных процедур
        //   `,
        //   'order-certification': `
        //     <strong>Инструкция для логиста - Сертификация:</strong><br>
        //     • Проверьте сертификаты на перевозимые грузы<br>
        //     • Убедитесь в соответствии требованиям перевозки<br>
        //     • Следите за актуальностью сертификатов<br>
        //     • Контролируйте соблюдение требований при перевозке
        //   `,
        //   'order-consulting': `
        //     <strong>Инструкция для логиста - Консалтинг:</strong><br>
        //     • Предоставляйте консультации по логистике<br>
        //     • Помогайте в выборе оптимальных маршрутов<br>
        //     • Консультируйте по вопросам транспортировки<br>
        //     • Оказывайте поддержку по логистическим вопросам
        //   `,
        //   'order-logistics': `
        //     <strong>Инструкция для логиста - Логистика:</strong><br>
        //     • Планируйте оптимальные маршруты доставки<br>
        //     • Выбирайте подходящий транспорт<br>
        //     • Контролируйте процесс транспортировки<br>
        //     • Следите за своевременностью доставки
        //   `,
        //   'order-pnk': `
        //     <strong>Инструкция для логиста - ПНК:</strong><br>
        //     • Подготовьте документы для ПНК<br>
        //     • Проверьте корректность оформления<br>
        //     • Следите за сроками прохождения ПНК<br>
        //     • Контролируйте процесс проверки
        //   `,
        //   'order-svh': `
        //     <strong>Инструкция для логиста - СВХ:</strong><br>
        //     • Организуйте временное хранение на СВХ<br>
        //     • Контролируйте условия хранения<br>
        //     • Следите за сроками хранения<br>
        //     • Управляйте процессом выдачи грузов
        //   `,
        //   'order-insurance': `
        //     <strong>Инструкция для логиста - Страхование:</strong><br>
        //     • Проверьте страховое покрытие грузов<br>
        //     • Убедитесь в корректности страховых документов<br>
        //     • Следите за сроками действия страховки<br>
        //     • Контролируйте страховые случаи при перевозке
        //   `,
        //   'order-suppliers': `
        //     <strong>Инструкция для логиста - Поставщики:</strong><br>
        //     • Координируйте логистику с поставщиками<br>
        //     • Контролируйте своевременность поставок<br>
        //     • Следите за качеством логистических услуг поставщиков<br>
        //     • Оптимизируйте логистические процессы
        //   `
        // }
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.instruction-text {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  
  &__content {
    display: flex;
    align-items: flex-start;
    gap: 12px;
  }
  
  &__icon {
    flex-shrink: 0;
    margin-top: 2px;
  }
  
  &__text {
    flex: 1;
    font-size: 14px;
    line-height: 1.5;
    color: #495057;
    
    strong {
      color: #212529;
      font-weight: 600;
    }
  }
}
</style>
